/**
 * Product analytics.
 *
 * Every event goes to the Smart Laundry Basket GA4 property (loaded in
 * public/index.html) tagged with laundry_id. A shop that saved its own GA4 ID
 * also gets its own copy, and only on its own pages.
 *
 * Never pass names, emails, phone numbers or addresses: Google forbids PII.
 */

export const PLATFORM_GA4 = 'G-12EJBGPL36';
const GA4_ID = /^G-[A-Z0-9]{4,16}$/;

let tenant = { laundryId: null, ga4: null };
const loadedTenantIds = new Set();

function gtag() {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function g() { window.dataLayer.push(arguments); };
  }
  // eslint-disable-next-line prefer-rest-params
  window.gtag(...arguments);
}

/** Called when a shop's site loads. Pass an empty ga4Id when the shop has none. */
export function setTenantAnalytics(laundryId, ga4Id) {
  try {
    const id = GA4_ID.test(ga4Id || '') ? ga4Id : null;
    tenant = { laundryId: laundryId ? String(laundryId) : null, ga4: id };
    gtag('set', { laundry_id: tenant.laundryId || undefined });
    if (id && !loadedTenantIds.has(id)) {
      loadedTenantIds.add(id);
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      gtag('config', id);
    }
  } catch (e) {}
}

export function sendTargets() {
  return tenant.ga4 ? [PLATFORM_GA4, tenant.ga4] : [PLATFORM_GA4];
}

export function track(event, params = {}) {
  try {
    const clean = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') clean[k] = v;
    });
    if (tenant.laundryId && clean.laundry_id === undefined) clean.laundry_id = tenant.laundryId;
    gtag('event', event, { ...clean, send_to: sendTargets() });
  } catch (e) {}
}

export function _resetForTests() {
  tenant = { laundryId: null, ga4: null };
  loadedTenantIds.clear();
}
